<div class="invalid_label_container">
    <i
        *ngIf="hasIcon"
        class="ci ci-information ci--red"></i>
    <label class="invalid invalid_label">
        {{ labelText | translate }}
    </label>
</div>
